/** Форматирование денег Казны: сумы — числом с подписью «сум», валюта — со знаком. */

const NUMBER = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });

/** Число без единицы: «40 625 300». Для карточек цепочки и итогов в сумах. */
export const formatNumber = (amount: number) => NUMBER.format(amount);

/** Сумма в валюте записи: «4 210 300 сум», «312,00 $». */
export function formatMoney(amount: number, currency = 'UZS'): string {
  if (currency === 'UZS') return `${NUMBER.format(amount)} сум`;
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/** «2026-10-29» → «29.10.2026» (дата без времени, без сдвига часового пояса). */
export function formatDay(date: string | null | undefined): string {
  if (!date) return '—';
  const [y, m, d] = date.slice(0, 10).split('-');
  return y && m && d ? `${d}.${m}.${y}` : date;
}
